<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div style="width:100%">
            <div class="card mt-2">
              <div class="card-body">
                <div class="box-horizontal">
                  <div class="flex-1">
                    <div class="mb-2">
                      <div class="box-horizontal mb-0">
                        <div class="input-group flex-1 mr-2" v-show="cariByTelepon">
                          <input type="text" class="form-control" placeholder="Nama User (Kosongkan untuk muncul semua user)" v-model="telepon"/>
                          <button class="btn btn-outline-info" type="button" id="button-addon2" @click="cariTeleponApi()">Cari</button>
                        </div>
                        <div class="flex-1">
                          <button @click="cariByTelepon = true" v-show="!cariByTelepon" class="btn btn-info">Cari Pelanggan</button>
                          <button @click="modalFilter = true;cariByTelepon = false;" class="btn btn-success">Filter Pelanggan</button>
                        </div>
                        <div class="box-horizontal text-right mb-0">
                          <div class="mr-4" v-show="false">
                            <p class="card-title text-right">Total Pembayaran</p>
                            <h4 class="card-title text-right"><strong>{{ribu(totalBelum)}}</strong></h4>
                          </div>

                          <download-excel
                              style = "padding: 0"
                              :data   = "json_datapelanggan"
                              :fields = "json_fieldspelanggan"
                              worksheet = "My Worksheet"
                              :before-generate = "startDownload"
                              :title = "judulDoc"
                              :name    = "nameDoc">
                          
                            <button type="button" class="btn btn-info">EXPORT</button>
                          </download-excel>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-show="isCari">
                  <div class="col-md-12">
                    Hasil : 
                    <span class="badge badge-secondary" v-show="areaPilihNama != ''">Area : {{areaPilihNama}}</span> 
                    <span class="badge badge-secondary" v-show="adminNama != ''">Admin : {{adminNama}}</span> 
                    <span class="badge badge-secondary" v-show="paketNama != ''">Paket : {{paketNama}}</span> 
                    <span class="badge badge-secondary" v-show="telepon != ''">Cari : {{telepon}}</span> 
                    <span class="badge badge-secondary" v-show="tanggal != ''">Tanggal : {{tglIndo(tanggal)}}</span> 
                    <button class="btn btn-sm btn-secondary" @click="resetFilter">Reset</button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>PPOE</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Total Bayar</th>
                      <th>Via</th>
                      <th>Aksi</th>
                      <th v-show="cekWA">Pilih</th>
                    </thead>
                    <tbody v-show="loading">
                      <tr>
                        <td colspan="7"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="7"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="7"><Loading></Loading></td>
                      </tr>
                    </tbody>
                    <tbody v-show="!loading">
                      <tr v-if="pelanggan.length == 0"><td></td><td>Tidak ada Data</td></tr>
                      <tr v-for="(u, index) in pelanggan">
                        <td>{{ index+1 }}</td>
                        <td><strong>{{ u.user.unama }}</strong></br>{{ u.user.wa }}</td>
                        <td><span class="text-info">{{ u.user.ppoe }}</span></td>
                        <td>{{ u.user.pnama }}</br>{{ ribu(u.user.ptarif) }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>
                          {{ ribu( u.user.paket_tarif ) 
                            }} 
                            <i class="tombol material-icons text-info" @mouseover="infoShow = index" @mouseleave="infoShow = -1">error</i> 
                          <span class="info" v-if="infoShow == index" v-show="infoShow == index">
                            <!--<p class="mb-0">PPN {{ppn}}% : {{ribu(parseInt(ppn) * ( parseInt(u.user.paket_tarif) / 100 ) )}}</p>-->
                            <p class="mb-0">PPN {{ppn}}% : {{ribu(u.user.ppn)}}</p>
                            <p class="mb-0">{{u.user.biaya_rincian}} : {{ribu(u.user.biaya1) }}</p>
                            <p class="mb-0">{{u.user.biaya_rincian_2}} : {{ribu(u.user.biaya2) }}</p>
                            <p class="mb-0">Diskon : {{ribu(u.user.diskon) }}</p>
                          </span>
                        </td>
                        <td>
                          <span v-if="u.user.via != null">
                            
                            <img class="icon" src="@/assets/qris.png" alt="" style="height: 35px;" v-if="u.user.via == 'qris'">
                            <img class="icon" src="@/assets/alfamidi.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'alfamidi'"> 
                            <img class="icon" src="@/assets/indomaret.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'indomaret'"> 
                            <img class="icon" src="@/assets/indomaret.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'INDOMARET'"> 
                            <img class="icon" src="@/assets/alfamart.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'ALFAMART'"> 
                            <img class="icon" src="@/assets/permata.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'PERMATA'"> 
                            <img class="icon" src="@/assets/bni.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'BNI'"> 
                            <img class="icon" src="@/assets/bri.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'BRI'"> 
                            <img class="icon" src="@/assets/mandiri.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'MANDIRI'"> 
                            <img class="icon" src="@/assets/ovo.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'ovo'"> 
                            <img class="icon" src="@/assets/dana.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'dana'"> 
                            <img class="icon" src="@/assets/link.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'linkaja'"> 
                            
                          </span>
                          <span v-else>{{ u.user.by_admin }}</br></span>
                        </td>
                        <td>
                          <router-link :to="{ name: 'pelanggan-detail', params: { id:u.user.uid, user: u.user, area: u.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i></router-link>

                          <!-- <button v-show="isAllow()" @click="showing = index, idHapus = u.user.uid" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button> -->
                        </td>
                        <td v-show="cekWA">
                          <input type="checkbox" id="jack" :value="u.user" v-model="checkedNames">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer " v-show="!isCari && !loading">
                

                <div class="d-block" style="width:100%">
                  <div class="text-center" style="width:100%">
                    <button class="btn btn-info" @click="loadMore()" v-show="pageStat != 999">Load More {{pageLimit}}+</button>
                    <!-- <button class="btn btn-success" @click="loadAll(); pageStat = 999" v-show="pageStat != 999">Load All</button> -->
                  </div>
                  <div class="text-center" style="width:100%">
                    <span>Nyari Load All ya? di tiadakan dulu ya, tapi tiap loadmore udah {{pageLimit}} pelanggan kok :)</span>
                  </div>
                </div>

                <!-- 
                <div class="text-center" style="width:100%">
                  <button class="btn btn-info" @click="loadMore()" v-show="pageStat != 999">Load More...</button>
                  <button class="btn btn-success" @click="loadAll(); pageStat = 999" v-show="pageStat != 999">Load All</button>
                </div>
                -->

              </div>
            </div>
          </div>
      </div>
      
      <!-- MODAL FILTER -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalBayar">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Bayar Sekarang</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
            <div class="modal-body" v-show="doneBayar">
              <div class="text-center d-block">
                Pembayaran Berhasil! Kirim via WA ga?</br>
                <button class="btn btn-sm btn-success" @click="kirimWA()">
                  Kirim WA
                </button>
              </div>
              <div class="text-center d-block">
                Atau di cetak aja?</br>
                <button class="btn btn-sm btn-info" @click="print()">
                  Cetak Lur
                </button>
              </div>
            </div>
						<div class="modal-body" v-show="!doneBayar">
							<div class="row">
                <div class="col-md-12" style="height: 400px;overflow:auto">
                  <div class="row" v-show="loadingBayar">
                      <div class="col-md-12">
                          <div class="form-group">
                              <div class="form-group">
                                <p class="text-center">Sedang mengambil data...</p>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row" v-show="!loadingBayar">
										<div class="col-md-12" style="height: 450px;overflow: auto;" v-if="bdata != null">
                        <div class="form-group">
                            <label class="bmd-label-floating">Pelanggan</label>
                            <p class="mb-0">{{bdata.unama}} (#{{bdata.fake_id}})</p>
                            <p class="mb-0">{{bdata.wa}}</p>
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">Pembayaran</label>
                            <div class="box-horizontal m-0">
                              <p class="flex-1 m-0">{{bdata.pnama}}</p>
                              <p class="m-0">{{ribu(bdata.ptarif)}}</p>
                            </div>
                            <div class="box-horizontal m-0">
                              <p class="flex-1 m-0">PPN {{ppn}}%</p>
                              <p class="m-0">{{ribu((bdata.ptarif / 100) * ppn)}}</p>
                            </div>
                            <div class="box-horizontal m-0" v-show="bdata.biaya_rincian != null && bdata.biaya_rincian != ''">
                              <p class="flex-1 m-0">{{bdata.biaya_rincian}}</p>
                              <p class="m-0">{{ribu(bdata.biaya_tambahan)}}</p>
                            </div>
                            <div class="box-horizontal m-0" v-show="bdata.biaya_rincian_2 != null && bdata.biaya_rincian != ''">
                              <p class="flex-1 m-0">{{bdata.biaya_rincian_2}}</p>
                              <p class="m-0">{{ribu(bdata.biaya_tambahan_2)}}</p>
                            </div>
                            <div class="box-horizontal m-0" v-show="bdata.diskon">
                              <p class="flex-1 m-0">Diskon</p>
                              <p class="m-0">{{ribu(bdata.diskon )}}</p>
                            </div>
                            <div class="box-horizontal m-0">
                              <p class="flex-1 m-0">Biaya Perbulan</p>
                              <p class="m-0">{{ribu(
                                 bTotal
                                )}}</p>
                            </div>
                        </div>
                        <div class="form-group">
                          <label class="bmd-label-floating">Bulan Tagihan</label>
                          <p class="flex-1 m-0" v-show="bBulan3.isBayar == null">{{bBulan3.bulanText}} {{bBulan3.tahunAngka}}</p>
                          <p class="flex-1 m-0" v-show="bBulan2.isBayar == null">{{bBulan2.bulanText}} {{bBulan2.tahunAngka}}</p>
                          <p class="flex-1 m-0" v-show="bBulan1.isBayar == null">{{bBulan1.bulanText}} {{bBulan1.tahunAngka}}</p>
                          <p class="flex-1 m-0" v-show="bBulan0.isBayar == null">{{bBulan0.bulanText}} {{bBulan0.tahunAngka}}</p>
                        </div>
                      </div>
                  </div>
                </div>
							</div>
						</div>
            <div class="modal-footer" v-show="!doneBayar">
              <div class="box-horizontal mb-0" style="width:100%">
                <div class="flex-1">
                  <span class="d-block">Total Pembayaran</span>
                  <strong class="d-block">{{ribu(bTotalAll)}}</strong>
                </div>
                <div>
                  <button class="btn btn-secondary btn-sm" @click="modalBayar = false">Batal</button>
                  <button class="btn btn-info btn-sm" @click="bayarSekarang()">Bayar Sekarang</button>
                </div>
              </div>
            </div>
					</div>
				</div>
			</div>
      
      <!-- MODAL FILTER -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalFilter">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Filterisasi</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalFilter = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12" style="height: 400px;overflow:auto">
                  <div class="row">
                      <div class="col-md-12">
                          <div class="form-group">
                              <div class="form-group">
                                  <label class="bmd-label-floating">Area</label>
                                  <select class="form-control" placeholder="Pilih Area..." v-model="areaPilih">
                                      <option value="" selected disabled>Pilih Area</option>
                                      <option v-for="(u, index) in area" :value="u.id"  @click="pilihArea(u.id,u.nama);">{{u.nama}}</option>
                                  </select>
                              </div>
                          </div>
                          <div class="form-group">
                              <div class="form-group">
                                <label class="bmd-label-floating">Tanggal Tagihan</label>
                                <vuejs-datepicker :format="customFormatter" placeholder="Tanggal..." style="width:100%" v-model="tanggal"></vuejs-datepicker>
                              </div>
                          </div>
                          <div class="form-group">
                              <div class="form-group">
                                  <label class="bmd-label-floating">By Admin</label>
                                  <select class="form-control" placeholder="Pilih Admin..." v-model="adminID">
                                      <option value="" selected disabled>Pilih Admin</option>
                                      <option v-for="(u, index) in admin" :value="u.id"  @click="pilihAdmin(u.id,u.nama)">{{u.nama}}</option>
                                  </select>
                              </div>
                          </div>
                          <div class="form-group">
                              <div class="form-group">
                                  <label class="bmd-label-floating">Paket</label>
                                  <select class="form-control" placeholder="Pilih Area..." v-model="paketID">
                                      <option value="" selected disabled>Pilih Paket</option>
                                      <option v-for="(u, index) in paket" :value="u.id" @click="pilihPaket(u.id,u.nama)">{{u.nama}} - {{ribu(u.tarif)}}</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
							</div>
						</div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="resetFilter();">Reset Filter</button>
              <button class="btn btn-info" @click="CariMulti(); modalFilter = false">Filter Sekarang</button>
            </div>
					</div>
				</div>
			</div>
      
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import vuejsDatepicker, { data } from 'vuejs-datepicker'
import inter from '@/globalFunc/Interface' 
import myGlobal from '@/globalFunc/myGlobal' 
import Loading from '@/globalFunc/Loading' 
import { RedisSession } from '@/globalFunc/redis';

Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
import tambahPoinVue from '../NOPAKAI/BACKUP/sales/tambah-poin.vue'
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'Loading': Loading
  }, 
  sockets: {
    connection: function(){
      console.log('socket connected')
    },
    message: function(val){
      console.log(val)
    },
    sent: function(val) {
      //console.log(val)
      
      if(val == "sukses") {
        this.pesanKirimPause = "Pesan berhasil Dikirim";
        this.modalWAFooter = true;
        this.cekWA = false;
        this.checkedNames = [];
      } else if (val == "start") {
        this.pesanKirimPause = "Mulai Mengirim Pesan..";
      } else if (val == "restart") {
        this.pesanKirimPause = "Lanjoet Mengirim Pesan...";
      } else if (val == "pause") {
        this.pesanKirimPause = "Di Pause 15s, biar ga ke blokir akak No WhatsAppnya";
      } else {
        this.pesanKirim = val;
        this.progress = this.progress + 1;
      }
    }
  },
  data () { 
    return {
      loading: true,
      pageNow: 'lunasnow',
      pelanggan: [],
      area: [],
      pelangganCari: [],
      cariByTelepon: false,
      namaQ: '',

      modalBayar: false,
      loadingBayar: true,
      bdata: null,
      bTotal: 0,
      bTotalAll: 0,
      bBulan3: null, 
      bBulan2: null, 
      bBulan1: null, 
      bBulan0: null, // bulan sekarang 
      bayarBT0: null,
      bayarBT1: null,
      bayarBT2: null,
      bayarBT3: null,
      
      showing: -1,

      telepon: '',
      bulan: '',

      dariTanggal: '',
      statuse: '',
      filtered: '',

      // hapus
      idHapus: '',
      
      // cari kurir
      cariPelanggan: '',
      textCariPelanggan: '',
      textSalah: '',
      idPelanggan: '',
      namaPelanggan: '',

      // topup
      topup: '',
      password: '',

      totalBelum: 0,

      // modal 
      modalTopup: false,
      preCari: true,

      isCari: false,

      
      dariTanggal: 'null',
      areaId: 'null',
      areaName: '',

      //
      ppn: '',
      infoShow: -1,

      modalAdmin: false,
      modalFilter: false,

      modalPaket: false,
      paket: [],
      modalArea: false,
      admin: [],

      bulanBase: '',
      tahunBase: '',
      
      modalWA: false,
      modalWAFooter: false,
      cekWA: false,
      checkedNames: [],
      sesi: '',
      pesanKirim: '',
      pesanKirimPause: '',
      progress: 0,
      totalProgress: 0,

      judulDoc: '',
      nameDoc: '',
      json_fieldspelanggan: {
        "No" : 'no',
        'PPOE': 'ppoe',
        'Nama': 'nama',
        'Telepon': 'telepon',
        'Paket': 'paket',
        'Area': 'area',
        'Alamat': 'alamat',
        'Biaya': 'biaya',
        'Tanggal Tagihan': 'tanggal',
        'Rincian Tambahan 1': 'r1',
        'Biaya Tambahan 1': 'b1',
        'Rincian Tambahan 2': 'r2',
        'Biaya Tambahan 2': 'b2',
        'Diskon': 'diskon',
        'PPN': 'ppn',
        'Tarif PPN': 'ppn_tarif',
        'Total Bayar': 'total'
      },
      json_datapelanggan: [],
      json_metapelanggan: [
          [
              {
                  'key': 'charset',
                  'value': 'utf-8'
              }
          ]
      ],

      page: 0,
      pageStat: 0,
      pageLimit: "15",


      // CARI MULTI
      areaPilih: '',
      areaPilihNama: '',
      adminID: '',
      tanggal: '',
      adminNama: '',
      paketID: '',
      paketNama: '',

      Hid: '', // last id bayar
      printTanggal: null,
      printJam: null,
      TotalBiayaPrint: null,
      doneBayar: false
    }
  },
  methods: {
    kirimWA() {
      var ppne = (this.bdata.ptarif / 100) * this.ppn;
      var ppnText = "PPN " + myGlobal.PPN() + "% : " + myGlobal.ribu(ppne) + "\n";
      var TextRincian1 = "Biaya "+ this.bdata.biaya_rincian + " : " +myGlobal.ribu(this.bdata.biaya_tambahan) + "\n";
      if (this.bdata.biaya_rincian == null || this.bdata.biaya_rincian == '') {
        TextRincian1 = "";
      }
      var TextRincian2 = "Biaya "+ this.bdata.biaya_rincian_2 + " : " +myGlobal.ribu(this.bdata.biaya_tambahan_2) + "\n";
      if (this.bdata.biaya_rincian_2 == null || this.bdata.biaya_rincian_2 == '') {
        TextRincian2 = "";
      }
      var TextDiskon = "Diskon  : " +myGlobal.ribu(this.bdata.diskon) + "\n";
      if (this.bdata.diskon == null || this.bdata.diskon == '') {
        TextDiskon = "";
      }
      var bulanBayarPrint1 = "- "+myGlobal.BulanOnly(this.bayarBT1)+"\n";
      if (this.bayarBT1 == null) {
        bulanBayarPrint1 = "";
      }
      var bulanBayarPrint2 = "- "+myGlobal.BulanOnly(this.bayarBT2)+"\n";
      if (this.bayarBT2 == null) {
        bulanBayarPrint2 = "";
      }
      var bulanBayarPrint3 = "- "+myGlobal.BulanOnly(this.bayarBT3)+"\n";
      if (this.bayarBT3 == null) {
        bulanBayarPrint3 = "";
      }

      var t = "*"+sessionStorage.getItem('admin')+"* \n\n"+
                "*NOTA ELEKTRONIK*\n"+
                "https://wifiku.web.id/nota/?id="+this.Hid+"\n\n"+
                "Yth. Bapak / Ibu\n"+this.bdata.unama+"\n"+this.bdata.wa+"\n\n*PEMBAYARAN*\n"+
                "Tanggal Bayar : "+ this.printTanggal +" | "+ this.printJam +"\n" +
                "\nTagihan Bulan : \n"+
                "- "+myGlobal.BulanOnly(this.bayarBT0)+"\n" + bulanBayarPrint1 + bulanBayarPrint2 + bulanBayarPrint3 +
                "Jenis Paket : "+this.bdata.pnama+"\nHarga Paket : "+myGlobal.ribu(this.bdata.ptarif)+"\n" + ppnText +TextRincian1 + TextRincian2 + TextDiskon +
                "Total Biaya : "+myGlobal.ribu(this.TotalBiayaPrint)+"\n" +
                "Ket : *LUNAS* \nAdmin By : "+sessionStorage.getItem('admin')+"\n\n" +sessionStorage.getItem('myInfoPrint') + "\n\n" + sessionStorage.getItem('supportby');
      var text = encodeURIComponent(t);
      var noWa = this.bdata.wa;
      var first = noWa.charAt(0);
      if (first == "0") {
        noWa = "62"+noWa.substring(1);
      }

      this.modalBayar = false;
      this.doneBayar = false;
      
      window.open('https://wa.me/'+noWa+'?text='+text, '_blank');
    },
    print() {
      alert("Segera ya :)");

      this.modalBayar = false;
      this.doneBayar = false;
    },
    close() {
      this.modalBayar = false;
      this.doneBayar = false;
    },
    bayarSekarang() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        id: this.bdata.uid,
        bulantahun0: this.bayarBT0,
        bulantahun1: this.bayarBT1,
        bulantahun2: this.bayarBT2,
        bulantahun3: this.bayarBT3,
        biaya1: this.bdata.biaya_tambahan,
        biaya2: this.bdata.biaya_tambahan_2,
        rincian1: this.bdata.biaya_rincian,
        rincian2: this.bdata.biaya_rincian_2,
        diskon: this.bdata.diskon
      }
      //     
      var apiUrl = inter.postBayarNew();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x));
        if (x.status) {
          this.loading = true;
          this.Hid = x.data.hid;
          this.TotalBiayaPrint = x.data.tarif;
          this.printTanggal = x.data.tanggal;
          this.printJam = x.data.jam;
          this.doneBayar = true;
          this.getData();
        } else {
          alert(x.pesan);
        }
      })
    }, 
    tagihanCek(u) {
      //console.log(JSON.stringify(u));
      this.bTotal = 0; 
      this.bTotalAll = 0; 

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        id: this.idPelanggan,
        bulan: myGlobal.getBulan,
        tahun: myGlobal.getTahunNow
      }
      
      var apiUrl = inter.tagihanCek();
      this.PostData(data,apiUrl).then(x => {

        if (x.status) {
          this.bdata = u;
          var ppne = (u.ptarif / 100) * this.ppn;
          this.bTotal += (parseInt(myGlobal.isNull(u.biaya_tambahan)) +  parseInt(myGlobal.isNull(u.biaya_tambahan_2)) + parseInt(u.ptarif) + ppne) - myGlobal.isNull(u.diskon);
          
          var d = x.data;
          this.bBulan3 = d.bulanmin3data;
          this.bBulan2 = d.bulanmin2data;
          this.bBulan1 = d.bulanmin1data;
          this.bBulan0 = d.bulanmin0data;

          if (this.bBulan3.isBayar == null) {
            this.bTotalAll = this.bTotalAll + parseInt(this.bTotal);
            this.bayarBT3 = this.bBulan3.tahunAngka + "-" + this.bBulan3.bulanAngka;
          }
          if (this.bBulan2.isBayar == null) {
            this.bTotalAll = this.bTotalAll + parseInt(this.bTotal);
            this.bayarBT2 = this.bBulan2.tahunAngka + "-" + this.bBulan2.bulanAngka;
          }
          if (this.bBulan1.isBayar == null) {
            this.bTotalAll = this.bTotalAll + parseInt(this.bTotal);
            this.bayarBT1 = this.bBulan1.tahunAngka + "-" + this.bBulan1.bulanAngka;
          }
          if (this.bBulan0.isBayar == null) {
            this.bTotalAll = this.bTotalAll + parseInt(this.bTotal);
            this.bayarBT0 = this.bBulan0.tahunAngka + "-" + this.bBulan0.bulanAngka;
          }

        } else {
          //alert(x.pesan);
        }

        this.loadingBayar = false;
      })
    },
    pilihSemua() {
      this.checkedNames = [];
      //if (!this.allSelected) {
      for (let i = 0; i < this.pelanggan.length; i++) {
          this.checkedNames.push(this.pelanggan[i].user);
      }
      //console.log(JSON.stringify(this.checkedNames.length));
      //}
    },
    getPaket() {
      let cacheT = "belum_paket"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          if (x.status) {
            this.paket = x.data;
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      this.isCari = false;

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken')
      }
      
      var apiUrl = inter.ListPaket();
      this.PostData(data,apiUrl).then(x => {

        RedisSession.set(cacheT, x, 600000); // 10 menit

        if (x.status) {
          this.paket = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    },

    getAdmin() {

      
      let cacheT = "belum_admin"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          if (x.status) {
            this.admin = x.data;
          } else {
            //alert(x.pesan);
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      this.isCari = false;

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        is: "tagih"
      }
      
      var apiUrl = inter.AdminList();
      this.PostData(data,apiUrl).then(x => {

        RedisSession.set(cacheT, x, 600000); // 10 menit

        if (x.status) {
          this.admin = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    },
    startDownload() {

    },
    pilihArea(id,nama) {
      this.areaId = id;
      this.areaName = nama;

      this.areaPilih = id;
      this.areaPilihNama = nama;
    },
    pilihAdmin(id,nama) {
      this.adminID = id, this.adminNama = nama;
    },
    pilihPaket(id,nama) {
      this.paketID = id, this.paketNama = nama;
    },
    CariMulti() {
      this.isCari = true;

      //console.log(moment(this.tanggal).format('D MMMM YYYY'));
      /*
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "belum");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      */

      let data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        type: this.pageNow,
        bulan: sessionStorage.getItem('bulanIdBase'),
        tahun: sessionStorage.getItem('tahunBase'),
        admin: this.adminNama,
        adminid: this.adminID,
        area: this.areaPilih,
        paket: this.paketID
      }

      if (this.tanggal != "") { 
        data["tanggal"] = moment(this.tanggal).format('DD'),
        data["sampai"] = moment(this.tanggal).format('DD')
      }

      //console.log(JSON.stringify(data));
      
      var apiUrl = inter.getUserCariMultiFilter();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;
        if (x.status) {
          this.pelanggan = x.data;
          this.totalBelum = x.pesan;
          
          this.parseExcel(x.data, "");
          
        } else {
          this.pelanggan = null;
          this.totalBelum = 0;
        }
      })
    },

    resetFilter() {
      this.isCari = false;
      this.areaPilih = '',
      this.areaPilihNama = '',
      this.adminID = '',
      this.tanggal = '',
      this.adminNama = '',
      this.paketID = '',
      this.paketNama = '';
      this.telepon = '';
      this.cariByTelepon = false;

      this.getData();
    },
    isNull(x) {
      var a;
      if (x == null || x == "") {
        a = 0;
      } else {
        a = x
      }
      return a;
    },
    customFormatter (date) {
        return moment(date).format('DD');
    },
    cariTelepon() {
      this.cariByTelepon = true;
    },
    cariTeleponApi() {

      this.isCari = true;

      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.telepon);
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      data.append('type', this.pageNow);
      data.append('by', "nama");
      
      var apiUrl = inter.PelangganListCari();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x));
        if (x.status == true) {

          this.pelanggan = x.data;
        } else {
          this.pelanggan = null;

          this.textCariPelanggan = x.pesan;
        }
      })
    },
    hapusUser(item) {
      
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idHapus);
      
      var apiUrl = 'hapusUser';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.getData();
          this.showing = -1;
        } else {
          //alert(x.pesan);
        }
      })

    },
    getArea() {
      let cacheT = "pel_belum_area"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          if (x.status) {
            this.area = x.data;

          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      // >> ambil baru
      myGlobal.loger("AMBIL BARU");

      // for filter
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', this.pageNow);
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      
      var apiUrl = inter.ListArea(); //'ListArea'
      this.PostData(data,apiUrl).then(x => {

        RedisSession.set(cacheT, x, 600000); // 10 menit

        // myGlobal.loger(x)
        if (x.status) {
          this.area = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    },
    parseExcel(x,judul) {
      var data = x;
      var values = [];
      var i;
      for (i = 0; i < data.length; i++) {
        
          var telepon = data[i].user.wa;
          if (telepon.charAt(0) == "0") {
            telepon = "62"+telepon.substring(1);
          } else if (telepon.charAt(0) == "8") {
            telepon = "62"+telepon;
          }
          
          var item1 = {
              "no" : i+1,
              'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
              'telepon': telepon,
              'paket': data[i].user.pnama,
              'area': data[i].area,
              'alamat': data[i].user.alamat,
              'biaya': data[i].user.ptarif,
              'ppoe': data[i].user.ppoe,
              'tanggal': data[i].user.tanggal_tagihan,
              'r1': data[i].user.biaya_rincian,
              'b1': data[i].user.biaya_tambahan,
              'r2': data[i].user.biaya_rincian_2,
              'b2': data[i].user.biaya_tambahan_2,
              'diskon': data[i].user.diskon, 
              'ppn': this.ppn+"%", 
              'ppn_tarif': data[i].user.ppn, 
              'total': data[i].user.paket_tarif
              /*
              'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) ) */
          };
          values.push(item1);
      }
      this.json_datapelanggan = values;          
      this.judulDoc = ["Pelanggan Lunas Bayar "+judul+" - "+this.tglIndo(new Date)];
      this.nameDoc = "Pelanggan Lunas Bayar "+judul+" - "+this.tglIndo(new Date)+".xls";
    },
    loadMore() {
      this.page = this.page + 1;

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', this.pageNow);
      data.append('page', this.page);
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      data.append('limit', this.pageLimit);

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;
        if (x.status) {
          var data = x.data;
          var i;
          
          for (i = 0; i < data.length; i++) {
            this.pelanggan.push(data[i]);
          }
          //this.pelanggan = x.data;
          this.totalBelum = parseInt(this.totalBelum) + parseInt(x.pesan);

          /*

          // PASANG DATA BARU
          let waktu = myGlobal.timeNow();
          let polling = {
            time: waktu,
            d: this.pelanggan,
            page: this.page
          }
          sessionStorage.setItem("main_now_getData", JSON.stringify(polling));

          */

          //this.parseExcel(this.pelanggan, "");

        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    loadAll() {
      return false;

      this.page = this.page + 1;

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', this.pageNow);
      data.append('page', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;
        if (x.status) {
          
          this.pelanggan = x.data;
          this.totalBelum = x.pesan;

          this.parseExcel(x.data, "");
          
        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    loadAllExport() {
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', this.pageNow);
      data.append('page', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;

        if (x.status) {
          this.totalBelum = x.pesan;
          this.parseExcel(x.data, "");
        } else {
          this.pageStat = 999;
        }
      })
    },
    getData() {

      let bulan = sessionStorage.getItem('bulanIdBase');
      let tahun = sessionStorage.getItem('tahunBase');
    
      let cacheT = "pel_lunasnow-"+bulan+"-"+tahun+"-page0"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH

          this.loading = false;
          if (x.status) {
            this.pelanggan = x.data;
            this.totalBelum = x.pesan;
            
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', this.pageNow);
      data.append('page', this.page);
      data.append('bulan', bulan);
      data.append('tahun', tahun);
      

      data.append('limit', this.pageLimit);

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        RedisSession.set(cacheT, x, 300000); // 5 menit

        this.loading = false;
        if (x.status) {
          this.pelanggan = x.data;
          this.totalBelum = x.pesan;
          
        } else {
          //alert(x.pesan);
        }
      })
    },
  },
  mounted () {
    document.title = "List Pelanggan Lunas Bayar";
    this.namaQ = sessionStorage.getItem('admin');

    this.ppn = myGlobal.PPN();

    this.getData();
    this.getArea();
    this.getAdmin();
    this.getPaket();
    // this.loadAllExport();

    var bulanNow = this.getBulanNow();
    this.bulanBase = bulanNow;
    this.tahunBase = this.getTahunNow();

		//console.log(JSON.stringify(this.$route.params));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.tombol {
  cursor: pointer;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan-lunas/main-now.vue